export default __webpack_public_path__ + "static/media/32-icon-error.0c9ba04a.svg";